import { RootState } from '@src/store/store'
import { ContactsStateType } from '@src/store/ducks/contacts/reducer'

export const selectContacts = (state: RootState): ContactsStateType => state.contacts

export const selectContactsIsSuccessCallBack = (state: RootState): boolean => selectContacts(state).isSuccessCallBack
export const selectLoadingIsSuccessCallBack = (state: RootState): boolean => selectContacts(state).isLoadingCallBack
export const selectContactsIsLoadingTariffRequest = (state: RootState): boolean => selectContacts(state).isLoadingTariffRequest
export const selectContactsIsSuccessTariffRequest = (state: RootState): boolean => selectContacts(state).isSuccessTariffRequest
